// extracted by mini-css-extract-plugin
export default {"input":"w9-z","button":"x9-z","selected":"y9-z","unavailable":"z9-z","oos":"A9-z","image":"B9-z","paperCutDisabledOverlay":"C9-z"};